import React, { useState, useEffect } from 'react';
import { Menu, X, User, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Header = ({ onBookConsultation }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState('logo_monogram'); // Default
  const navigate = useNavigate();

  useEffect(() => {
    fetchSelectedLogo();
  }, []);

  const fetchSelectedLogo = async () => {
    try {
      const response = await axios.get(`${API}/settings/selected_logo`);
      setSelectedLogo(response.data.setting_value);
    } catch (error) {
      console.log('Using default logo (monogram)');
    }
  };

  const scrollToSection = (sectionId) => {
    // Check if we're on home page - now at /home
    if (window.location.pathname !== '/home') {
      navigate('/home');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          // Focus on name input if navigating to contact section
          if (sectionId === 'contact') {
            setTimeout(() => {
              const nameInput = document.getElementById('name');
              if (nameInput) {
                nameInput.focus();
              }
            }, 600);
          }
        }
      }, 300);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        // Focus on name input if navigating to contact section
        if (sectionId === 'contact') {
          setTimeout(() => {
            const nameInput = document.getElementById('name');
            if (nameInput) {
              nameInput.focus();
            }
          }, 600);
        }
      }
    }
    setMobileMenuOpen(false);
  };

  const handleBookConsultation = () => {
    // Clear any pre-selected country
    if (onBookConsultation) {
      onBookConsultation();
    }
    
    // Scroll to contact section
    scrollToSection('contact');
    
    // Focus on Full Name input field after scrolling
    setTimeout(() => {
      const nameInput = document.getElementById('name');
      if (nameInput) {
        nameInput.focus();
      }
    }, 600);
  };

  return (
    <header className="header-nav">
      <div className="header-container">
        <div className="logo-section">
          <img 
            src={`/${selectedLogo}.png`} 
            alt="Visaasure Logo" 
            className="header-logo"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <button onClick={() => navigate('/apply-online')} className="nav-link nav-link-primary">Apply Online</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
          <button onClick={() => scrollToSection('process')} className="nav-link">Process</button>
          <button onClick={() => scrollToSection('testimonials')} className="nav-link">Testimonials</button>
          <button onClick={() => navigate('/blogs')} className="nav-link">Our Blogs</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
        </nav>

        <div className="nav-actions">
          <button onClick={() => navigate('/partner/login')} className="btn-secondary login-btn-header btn-sm" style={{ marginRight: '8px' }}>
            <Building2 size={14} />
            <span>Partner</span>
          </button>
          <button onClick={() => navigate('/client-login')} className="btn-secondary login-btn-header btn-sm">
            <User size={14} />
            <span>Client</span>
          </button>
          <button onClick={handleBookConsultation} className="btn-primary btn-sm">
            Book Consultation
          </button>
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          <button onClick={() => { navigate('/apply-online'); setMobileMenuOpen(false); }} className="mobile-nav-link mobile-nav-primary">Apply Online</button>
          <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Services</button>
          <button onClick={() => scrollToSection('process')} className="mobile-nav-link">Process</button>
          <button onClick={() => scrollToSection('testimonials')} className="mobile-nav-link">Testimonials</button>
          <button onClick={() => navigate('/blogs')} className="mobile-nav-link">Our Blogs</button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
          <button onClick={() => { navigate('/partner/login'); setMobileMenuOpen(false); }} className="mobile-nav-link">Partner Login</button>
          <button onClick={() => navigate('/client-login')} className="mobile-nav-link">Client Login</button>
        </div>
      )}
    </header>
  );
};

export default Header;